import _ from "lodash";
import {useState} from "react";
import './Questionnaire.scss'
import {Card} from "react-bootstrap";
import {useReviewQuestionContext} from "../../lib/contexLib";
import Question from "../../components/Question/Question";
import {EQuestionCategory} from "../../const/dataEnum";
import {FmlxIcon} from "fmlx-common-ui";
import {generateMarkupFromDraftjs} from "../../lib/utilities";
import {isReviewCompleted} from "../../stores/business/reviewTaskBusiness";

export default function Questionnaire({
    title,
    notes,
    question
 }) {
  const [isOpen, setIsOpen] = useState(false)
  const {
    // genericReviews,
    // setGenericReview,
    // skillReviews,
    // setSkillReview,
    steps,
    setSteps,
    activeStep,
    readOnly,
    changedQuestionIds,
    setChangedQuestionIds
  } = useReviewQuestionContext();

  const changeIsCompleteStepperState = (steps) => {
    const newSteps = steps.map((step, index) => ({
      ...step,
      stepper: {
        ...step.stepper,
        isCompleted: isReviewCompleted(index === 0, step?.content?.question),
      }
    }));
    return newSteps;
  };

  const addQuestionIndex = (questionIndex) => {
    const question = steps[activeStep].content.question[questionIndex];
    const questionId = question.questionID;
    switch (question.category) {
      case EQuestionCategory.GENERAL: {
        if (!changedQuestionIds.employeeGenericReviewIds.includes(questionId)) {
          setChangedQuestionIds((q) => ({
            ...changedQuestionIds,
            employeeGenericReviewIds: [...q.employeeGenericReviewIds, questionId]
          }));
        }
        break;
      }
      case EQuestionCategory.SKILL: {
        if (!changedQuestionIds.employeeSkillReviewIds.includes(questionId)) {
          setChangedQuestionIds((q) => ({
            ...changedQuestionIds,
            employeeSkillReviewIds: [...q.employeeSkillReviewIds, questionId]
          }));
        }
        break;
      }
      default:
        break;
    }
  }

  function updateRating(index, rate) {
    const prevScore = steps[activeStep].content.question[index].score;

    if (prevScore !== rate) {
      let newSteps = steps.map((step, stepIndex) => {
        if (activeStep === stepIndex) {
          return {
            ...step,
            content: {
              ...step.content,
              question: step.content.question.map((questionItem, i) => {
                if (index === i) {
                  return {...questionItem, score: rate}
                }
                return questionItem;
              })
            }
          }
        }
        return step;
      })

      newSteps = changeIsCompleteStepperState(newSteps);

      setSteps(newSteps);
      addQuestionIndex(index);
    }
  }

  function updateComment(index, value) {
    let temp = _.cloneDeep(steps);
    temp[activeStep].content.question[index].comments = value;
    temp = changeIsCompleteStepperState(temp);
    setSteps(temp);
    addQuestionIndex(index);
  }

  function ResetAnswer(index) {
    let temp = _.cloneDeep(steps);
    temp[activeStep].content.question[index].score = null;
    temp[activeStep].content.question[index].comments = null;
    temp = changeIsCompleteStepperState(temp);
    setSteps(temp);
    addQuestionIndex(index);
  }

  const onNotQulifiedChangeHandler = (e, questionIndex) => {
    let newSteps = steps.map((step, stepIndex) => {
      if (activeStep === stepIndex) {
        return {
          ...step,
          content: {
            ...step.content,
            question: step.content.question.map((questionItem, i) => {
              if (questionIndex === i) {
                if (questionItem.isNotQualified) {
                  return {
                    ...questionItem,
                    isNotQualified: e.target.checked,
                    comments: '',
                  }
                }
                return {
                  ...questionItem,
                  score: null,
                  isNotQualified: e.target.checked,
                  comments: 'Not qualified to answer',
                }
              }
              return questionItem;
            })
          }
        }
      }
      return step;
    });
    newSteps = changeIsCompleteStepperState(newSteps);
    setSteps(newSteps);
    addQuestionIndex(questionIndex);
  }

  const toggleHandleCollapsible = () => {
    setIsOpen(!isOpen)
  }
  return (
    <div>
      <Card className="mb-4 skill-header">
        <Card.Body>
          <div className="title-heading" onClick={toggleHandleCollapsible} style={{cursor: "pointer"}}>
            {title}
            {isOpen ? <div onClick={toggleHandleCollapsible}><FmlxIcon name={'ChevronLeftCircle'}/></div> :
              <div><FmlxIcon name={'ChevronDownCircle'}/></div>}
          </div>
        </Card.Body>
        {isOpen && (
          <div className="notes-style">
            {notes === "" ? (
              <></>
            ) : (
              <div className="draft-js-container" dangerouslySetInnerHTML={generateMarkupFromDraftjs(notes)}></div>
            )}
          </div>
        )}
      </Card>

      {question?.map((data, i) => {
        const isRequired = data.required ?? true;
        return (
          <div key={i}>
            <Question
              required={isRequired}
              commentsRequired={data.commentsRequired}
              title={data.question}
              description={data.description}
              questionType={data.questionType}
              category={data.category}
              minText=""
              maxText=""
              score={data.score}
              isNotQualified={data.isNotQualified}
              updateComments={(event) => {
                updateComment(i, event.target.value);
              }}
              updateRating={(rate) => {
                updateRating(i, rate);
              }}
              readOnly={readOnly}
              comment={data.comments === null ? "" : data.comments}
              onReset={function () {
                ResetAnswer(i);
              }}
              onNotQulifiedChange={(e) => {
                onNotQulifiedChangeHandler(e, i);
              }}
              minimumofWords={data.minimumofWords}
            />
          </div>
        );
      })}
    </div>
  );
}
